import React from "react";
import PropTypes from "prop-types";
import Fields from "../Fields";

const Question = ({ question, onSubmit }) => {
  const { key, message, input } = question;

  return (
    <Fields
      type={input.type}
      id={key}
      name={key}
      label={message}
      choices={input.choices}
      validations={input.validations}
      onSubmit={onSubmit}
    />
  );
};

Question.propTypes = {
  question: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
};

export default Question;
